/**
 * Admin Dashboard Component
 * Only visible to admin users
 */

function AdminDashboard({ user }) {
    return (
        <div className="max-w-7xl mx-auto p-3 sm:p-6">
            <div className="mb-4 sm:mb-6">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">
                    لوحة تحكم المدير
                </h1>
                <p className="text-sm sm:text-base text-gray-600">
                    إدارة النظام والصلاحيات
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 mb-4 sm:mb-6">
                {/* Stats Cards */}
                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">المستخدمون</h3>
                    <p className="text-3xl font-bold text-blue-600">-</p>
                    <p className="text-sm text-gray-500 mt-1">إجمالي المستخدمين</p>
                </div>

                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">البلاغات</h3>
                    <p className="text-3xl font-bold text-green-600">-</p>
                    <p className="text-sm text-gray-500 mt-1">إجمالي البلاغات</p>
                </div>

                <div className="bg-white rounded-lg shadow p-6">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">التقارير</h3>
                    <p className="text-3xl font-bold text-purple-600">-</p>
                    <p className="text-sm text-gray-500 mt-1">إجمالي التقارير</p>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">إدارة سريعة</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                        <h3 className="font-semibold text-gray-900 mb-2">إدارة المستخدمين</h3>
                        <p className="text-sm text-gray-600">عرض وإدارة جميع المستخدمين</p>
                    </div>
                    <div className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                        <h3 className="font-semibold text-gray-900 mb-2">البلاغات</h3>
                        <p className="text-sm text-gray-600">عرض وإدارة البلاغات</p>
                    </div>
                    <div className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                        <h3 className="font-semibold text-gray-900 mb-2">التقارير</h3>
                        <p className="text-sm text-gray-600">عرض وإدارة التقارير</p>
                    </div>
                    <div className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors">
                        <h3 className="font-semibold text-gray-900 mb-2">الإحصائيات</h3>
                        <p className="text-sm text-gray-600">عرض إحصائيات النظام</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminDashboard;
